import { Service } from '@/tools'
export class StockReceiptTaskFormService<T extends TStock.StockReceiptTaskForm> extends Service {
  constructor(path: string) {
    super()
    this.setPathPrefix(path)
  }

  private post2<P extends TCommon.ApiVersion = 'v1'>(url: `${P}/${keyof TStock.StockReceiptTaskForm}`, data?: TCommon.Json, toast?: string) {
    return this.post(url, data, toast)
  }

  /**
   * 功能：收货任务单分页查询
   * /api/stock/stockReceiptTaskForm/v1/page
   */
  page = (data: T['ApiPage']['req']): Promise<T['ApiPage']['res']> => this.post2('v1/ApiPage', data)
  /**
   * 功能：到货确认
   * /api/stock/stockReceiptTaskForm/v1/arrivalConfirm
   */
  arrivalConfirm = (data: T['ApiArrivalConfirm']['req']): Promise<T['ApiArrivalConfirm']['res']> => this.post2('v1/ApiArrivalConfirm', data)
  /**
   * 功能：收货任务单详情
   * /api/stock/stockReceiptTaskForm/v1/detail
   */
  detail = (data: T['ApiDetail']['req']): Promise<T['ApiDetail']['res']> => this.post2('v1/ApiDetail', data)
  /**
   * 功能：待收货明细
   * /api/stock/stockReceiptTaskForm/v1/prepare
   */
  prepare = (data: T['ApiPrepare']['req']): Promise<T['ApiPrepare']['res']> => this.post2('v1/ApiPrepare', data)
  /**
   * 功能：收货确认
   * /api/stock/stockReceiptTaskForm/v1/submit
   */
  submit = (data: T['ApiSubmit']['req']): Promise<T['ApiSubmit']['res']> => this.post2('v1/ApiSubmit', data)
  /**
   * 功能：根据收货业务组查询授权业务仓
   * /api/stock/stockReceiptTaskForm/v1/getDistributeBizWhList
   */
  getDistributeBizWhList = (data: T['ApiGetDistributeBizWhList']['req']): Promise<T['ApiGetDistributeBizWhList']['res']> =>
    this.post2('v1/ApiGetDistributeBizWhList', data)
  /**
   * 功能：获取sku推荐上架位置
   * /api/stock/stockReceiptTaskForm/v1/getRecommandLocation
   */
  getRecommandLocation = (data: T['ApiGetRecommandLocation']['req']): Promise<T['ApiGetRecommandLocation']['res']> =>
    this.post2('v1/ApiGetRecommandLocation', data)
  /**
   * 功能：查看物流
   * /api/stock/stockReceiptTaskForm/v1/selectLogistics
   */
  selectLogistics = (data: T['ApiSelectLogistics']['req']): Promise<T['ApiSelectLogistics']['res']> => this.post2('v1/ApiSelectLogistics', data)
}
